import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { OracleResponsysDataset } from 'app/model/dataset/oracle-responsys.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'ResponsysSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(OracleResponsysDataset) }
})
export class OracleResponsysCopySource extends TabularCopySource {
}
